module.exports = __webpack_public_path__ + "static/media/wife_and_i.3b583ea9.jpg";